import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import React from "react";

export default function VisacostpaymentPopUp({
  showPromptElement,
  setshowPromptElement,
  propsData,
  setTrigger,
  trigger,
}) {
  console.log("PropsData to be seen here below.......", propsData);
  const [files, setFiles] = useState([]);
  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };
  const [amount, setAmount] = useState();
  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };
  const dropDownData = ["TAX INVOICE", "PAYMENT RECEIPT"];
  const token = localStorage.getItem("nodeToken");
  const [date, setDate] = useState(null);
  const [receivedDate, setReceivedDate] = useState();
  const [loading, setLoading] = useState(false);
  const [refNumber, setRefNumber] = useState();
  const dispatch = useDispatch();

  const [filetype, setFiletype] = useState();

  const handleFileTypeChange = (value) => {
    setFiletype(value);
  };

  const submitHandler = async (e, files, propsData) => {
    e.preventDefault();
    setLoading(true);
    console.log("........files.......", filetype);

    for (let file of files) {
      let type = file.name.split(".").pop();
      if (type !== "pdf") {
        dispatch(setAppError({ msg: "All files should be in PDF format" }));
        setLoading(false);
        return;
      }
    }
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file); // Ensure the field name is 'file'
    });
    formData.append("invoices_sent_date", date);
    formData.append("contract_id", propsData.contract_id);
    formData.append("invoice_type", filetype);

    try {
      const response = await nodeinstance.put(
        `/dashboard/visaSecurity/updateInvoice/${propsData.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setTrigger(!trigger);
        setshowPromptElement(false);
        setLoading(false);
        dispatch(
          setAppError({ msg: "Successfully uploaded.", color: "success" })
        );
      }
      console.log("success to be seen here......", response);
    } catch (err) {
      console.log("error", err);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full m-1">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setshowPromptElement(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={(e) => submitHandler(e, files, propsData)}
            className="w-full"
          >
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE SENT DATE
                </label>
                <input
                  type="Date"
                  value={date}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  REQUEST/INVOICE NO.
                </label>
                <input
                  type="text"
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  disabled
                  value={propsData?.invoice_number}
                />
              </div>
              <div className="flex flex-col gap-1 w-full max-w-md mt-2">
                <label htmlFor={`addOrEdit-name`} style={{ fontSize: "10px" }}>
                  CHOOSE FILE TYPE
                </label>
                <select
                  // {...register("visaprovider")}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-4 text-md"
                  onChange={(e) => {
                    handleFileTypeChange(e.target.value);
                  }}
                >
                  <option>{"select value"}</option>
                  {dropDownData?.map((data, index) => (
                    <React.Fragment key={index}>
                      <option value={data}>{data}</option>
                    </React.Fragment>
                  ))}
                </select>
              </div>
              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">Upload File</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full"
                  onChange={handleFileChange}
                  required
                  accept="application/pdf"
                  multiple
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ m: 2 }}
              >
                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                >
                  {" "}
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
